<template>
    <svg class="icon" :class="[symbol.id]" :viewBox="symbol.viewBox" :width="width" :height="height">
        <use :xlink:href="symbol.url ? symbol.url : '#' + symbol.id"></use>
    </svg>
</template>

<script>
    {
        function requireAll(r) { r.keys().forEach(r); }

        requireAll(require.context('../../icons/files/', false, /\.svg-files-sprite/));
        requireAll(require.context('../../icons/', false, /\.svg-sprite$/));
//        const _require = require.context('../../icons', true, /\.svg-sprite$/)
//        _require.keys().forEach(key => _require(key))
    }

    export default {
        props: {
            'originalDims': {
                default: null,
                type: Boolean
            },
            'symbol': {
                type: Object,
                required: true
            }
        },

        computed: {
            width() {
                if (!this.originalDims) return null;

                return this.symbol.width ?  this.symbol.width : this.getDimsFromViewBox().width;
            },

            height() {
                if (!this.originalDims) return null;

                return this.symbol.height ?  this.symbol.height : this.getDimsFromViewBox().height;
            }
        },

        methods: {
            getDimsFromViewBox: function () {
                const viewBoxParts = this.symbol.viewBox.split(' ');
                return {
                    width: parseFloat(viewBoxParts[2]),
                    height: parseFloat(viewBoxParts[3])
                }
            }
        },
    }
</script>

<style lang="scss">
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .icon {
        display: inline-block;

        &.icon-large {
            width: px-em(28px);
            height: px-em(28px);
            vertical-align: middle;
        }

        &.icon-inline {
            color: black;

            &:first-child:not(:last-child) {
                margin-right: .5em;
            }

            &:last-child:not(:first-child) {
                margin-left: .5em;
            }
        }

        &.icon-bookmark.icon-bookmark-active * {
            fill: $color-red;
        }

        &.icon-like.icon-like-active * {
            fill: $color-blue;
        }
    }

    .with-icon {
        padding-left: 2em;
        position: relative;

        .icon {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/SvgIcon.vue